<template>
  <div class="flex flex-col flex-shrink-0 z-30">
    <header class="bg-white border-b border-gray-100 h-14 flex items-center px-8 justify-between sticky top-0">
      <div class="flex items-center text-sm text-gray-500">
        <button @click="$emit('toggle-sidebar')" class="text-gray-400 mr-4 hover:text-[#F2C94C] transition-colors">
          <IconMenu class="w-5 h-5" />
        </button>

        <!-- 首页不显示面包屑 -->
        <template v-if="!isHomePage">
          <!-- 首页根节点 -->
          <button @click="handleRootClick" class="flex items-center gap-1 hover:text-[#F2C94C] transition-colors">
            <IconHome class="w-4 h-4" />
            <span>首页</span>
          </button>

          <!-- 专家案例详情页面的面包屑 -->
          <template v-if="isExpertCaseDetail">
            <!-- 从话题进入：首页 > 话题详情 > 案例详情 -->
            <template v-if="source === 'topic'">
              <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
              <button @click="handleBackToTopic" class="hover:text-[#F2C94C] transition-colors">
                话题详情
              </button>
              <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
              <span class="text-[#0A0F1D] font-medium">案例详情</span>
            </template>

            <!-- 从专家进入：首页 > 专家主页 > 案例详情 -->
            <template v-else-if="source === 'expert' && expert">
              <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
              <button @click="handleBackToExpert" class="hover:text-[#F2C94C] transition-colors">
                专家主页
              </button>
              <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
              <span class="text-[#0A0F1D] font-medium">案例详情</span>
            </template>

            <!-- 直接访问或其他情况：首页 > 案例详情 -->
            <template v-else>
              <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
              <span class="text-[#0A0F1D] font-medium">案例详情</span>
            </template>
          </template>

          <!-- 专家主页面包屑：首页 > 专家主页（固定） -->
          <template v-if="isExpertProfile && expert">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">专家主页</span>
          </template>

          <!-- 话题详情页面的面包屑：首页 > 话题详情（固定） -->
          <template v-if="isTopicDetail && selectedTopic">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">话题详情</span>
          </template>

          <!-- 深度诊断结果页面的面包屑：首页 > 深度诊断结果 -->
          <template v-if="isDiagnoseResultPage">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">深度诊断结果</span>
          </template>

          <!-- 诊断引擎页面的面包屑：首页 > 深度诊断 > 回答调研题目 -->
          <template v-if="isDiagnoseEngine">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-gray-400">深度诊断</span>
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">回答调研题目</span>
          </template>

          <!-- 历史记录页面的面包屑：首页 > 历史记录 -->
          <template v-if="isHistory">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">历史记录</span>
          </template>

          <!-- 个人中心页面的面包屑：首页 > 个人中心 -->
          <template v-if="isProfile">
            <IconChevronRight class="w-4 h-4 mx-2 text-gray-300" />
            <span class="text-[#0A0F1D] font-medium">个人中心</span>
          </template>
        </template>
      </div>
    </header>
  </div>
</template>

<script>
import { IconChevronRight, IconMenu, IconHome } from '../icons'
import { EXPERTS } from '../../data'

export default {
  name: 'AppHeader',
  components: {
    IconChevronRight,
    IconMenu,
    IconHome
  },
  props: {
    view: {
      type: String,
      default: 'home'
    },
    selectedTopic: {
      type: Object,
      default: null
    }
  },
  computed: {
    isExpertCaseDetail() {
      return this.$route.path.includes('/expert/') && this.$route.path.includes('/case/')
    },
    isExpertProfile() {
      return this.$route.path.includes('/expert/') && !this.$route.path.includes('/case/')
    },
    isTopicDetail() {
      return this.$route.path.includes('/topic/')
    },
    isDiagnoseResultPage() {
      return this.$route.path === '/diagnose-result'
    },
    isDiagnoseEngine() {
      return this.$route.path === '/diagnose-engine'
    },
    isHistory() {
      return this.$route.path === '/history'
    },
    isProfile() {
      return this.$route.path === '/profile'
    },
    isHome() {
      return this.$route.path === '/'
    },
    isPractice() {
      return this.$route.path === '/practice'
    },
    isHomePage() {
      return this.isHome || this.isPractice
    },
    source() {
      return this.$route.query.source
    },
    expert() {
      const expertId = this.$route.params.expertId
      return expertId ? EXPERTS.find(e => e.id === expertId) : null
    }
  },
  methods: {
    handleRootClick() {
      this.$emit('set-view', 'home')
      this.$emit('set-selected-topic', null)
      this.$router.push('/')
    },
    handleBackToExpert() {
      const expertId = this.$route.params.expertId
      if (expertId) {
        this.$router.push(`/expert/${expertId}`)
      } else {
        this.$router.push('/')
      }
    },
    handleBackToTopic() {
      this.$emit('set-view', 'home')
      this.$router.push('/')
    }
  }
}
</script>
